import { createFileRoute } from "@tanstack/react-router"

import { HomePage } from "@/reports/components/home-page"

export const Route = createFileRoute("/_app-shell/home")({
  head: () => ({ meta: [{ title: "Home - Kestly" }] }),
  component: () => <HomePage />,
})
